<template>
  <div class="tabbox">
    <div class="tbox">
      <div class="tboxtop">
        <div class="tableft">
          <div class="toptop">
            <div class="tableftrank">
              <div class="toprank">
                <div class="toprankfont">A股排名</div>
                <div class="topevaluate">
                  <div
                    class="tvfirst"
                    :class="[
                      tvfirstisActive ? 'tvfirstisActive' : 'tvfirstdisActive',
                    ]"
                  >
                    <div style="transform: scale(0.8571)">优秀</div>
                  </div>
                  <div
                    class="tvsecond"
                    :class="[
                      tvsecondisActive
                        ? 'tvsecondisActive'
                        : 'tvseconddisActive',
                    ]"
                  >
                    <div style="transform: scale(0.8571)">良好</div>
                  </div>
                  <div
                    class="tvthird"
                    :class="[
                      tvthirdisActive ? 'tvthirdisActive' : 'tvthirddisActive',
                    ]"
                  >
                    <div style="transform: scale(0.8571)">一般</div>
                  </div>
                  <div
                    class="tvfourth"
                    :class="[
                      tvfourthisActive
                        ? 'tvfourthisActive'
                        : 'tvfourthdisActive',
                    ]"
                  >
                    <div style="transform: scale(0.8571)">较差</div>
                  </div>
                </div>
              </div>
              <div class="bottomrank">
                <div class="bottomrankfont">行业排名</div>
                <div class="bottomevaluate">
                  <div class="topevaluate">
                    <div
                      class="tvfirst"
                      :class="[
                        BtvfirstisActive
                          ? 'tvfirstisActive'
                          : 'tvfirstdisActive',
                      ]"
                    >
                      <div style="transform: scale(0.8571)">优秀</div>
                    </div>
                    <div
                      class="tvsecond"
                      :class="[
                        BtvsecondisActive
                          ? 'tvsecondisActive'
                          : 'tvseconddisActive',
                      ]"
                    >
                      <div style="transform: scale(0.8571)">良好</div>
                    </div>
                    <div
                      class="tvthird"
                      :class="[
                        BtvthirdisActive
                          ? 'tvthirdisActive'
                          : 'tvthirddisActive',
                      ]"
                    >
                      <div style="transform: scale(0.8571)">一般</div>
                    </div>
                    <div
                      class="tvfourth"
                      :class="[
                        BtvfourthisActive
                          ? 'tvfourthisActive'
                          : 'tvfourthdisActive',
                      ]"
                    >
                      <div style="transform: scale(0.8571)">较差</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tablefttop">
              <div class="tabletfcount">
                {{ this.tabData.index_score }}
              </div>
              <div class="tablefticon">
                <div class="tablefticonup" v-if="this.tabData.diff > 0">
                  <img src="../../assets/white_theme/esg-sj-up.png" alt="" />
                </div>
                <div class="tablefticondown" v-if="this.tabData.diff < 0">
                  <img src="../../assets/white_theme/esg-sj-down.png" alt="" />
                </div>
                <div class="tablefticonequal" v-if="this.tabData.diff == 0">
                  <img
                    class="equeal"
                    src="../../assets/white_theme/esg-sj-equal.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="tabrank">
                <div class="everyranks" v-if="this.activeName == 'E'">
                  环境评分
                </div>
                <div class="everyranks" v-if="this.activeName == 'S'">
                  社会评分
                </div>
                <div class="everyranks" v-if="this.activeName == 'G'">
                  治理评分
                </div>
                <div class="everyranks" v-if="this.activeName == 'B'">
                  业务评分
                </div>
                <div class="everysumday">
                  {{ this.tabData.data_date }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tabright" v-if="this.activeName == 'E'">
          CN-ESG评价体系的环境主题主要考察企业在环境管理、资源能源消耗、排放、绿色建筑及科技这4个方面的表现，通过23个指标构成环境评价体系。
        </div>
        <div class="tabright" v-if="this.activeName == 'S'">
          CN-ESG评价体系的社会主题主要考察企业在社会、员工、供应商、隐私保护、产品和客户和知识产权、专利、奖项6个方面的表现，通过45个指标构成社会评价体系。
        </div>
        <div class="tabright" v-if="this.activeName == 'G'">
          CN-ESG评价体系的治理主题主要考察企业在公司战略、风险管理、董事会治理、信息披露等8个方面的表现，通过43个指标构成治理评价体系。
        </div>
        <div class="tabright" v-if="this.activeName == 'B'">
          CN-ESG评价体系的业务主题是企业所在行业的特色指标主题。根据企业所属行业不同进行动态调整。
        </div>
      </div>
      <div class="tboxdown">
        <div class="tboxtitle" v-if="this.activeName == 'E'">
          <div class="ttitle rtitle">
            <div class="circle"></div>
            <span class="circlef">环境评分分布</span>
          </div>
          <div class="ttitle">
            <div class="circle"></div>
            <span class="circlef">环境主题分布</span>
          </div>
        </div>
        <div class="tboxtitle" v-if="this.activeName == 'S'">
          <div class="ttitle rtitle">
            <div class="circle"></div>
            <span class="circlef">社会评分分布</span>
          </div>
          <div class="ttitle">
            <div class="circle"></div>
            <span class="circlef">社会主题分布</span>
          </div>
        </div>
        <div class="tboxtitle" v-if="this.activeName == 'G'">
          <div class="ttitle rtitle">
            <div class="circle"></div>
            <span class="circlef">治理评分分布</span>
          </div>
          <div class="ttitle">
            <div class="circle"></div>
            <span class="circlef">治理主题分布</span>
          </div>
        </div>
        <div class="tboxtitle" v-if="this.activeName == 'B'">
          <div class="ttitle rtitle">
            <div class="circle"></div>
            <span class="circlef">业务评分分布</span>
          </div>
          <div class="ttitle">
            <div class="circle"></div>
            <span class="circlef">业务主题分布</span>
          </div>
        </div>
        <div class="bottomtop">
          <div class="firstchart" style="height: 223px; width: 400px">
            <barchart :params="barparams" :url="barurl"></barchart>
          </div>
          <div class="secondchart" style="height: 223px; width: 500px">
            <radarchart :params="radarparams" :url="radarurl"></radarchart>
          </div>
        </div>
        <div class="tboxtitle">
          <div class="ttitle rtitle">
            <div class="circle"></div>
            <span class="circlef">同行业比较</span>
          </div>
          <div class="ttitle">
            <div class="circle"></div>
            <span class="circlef">同地区比较</span>
          </div>
        </div>
        <div class="bottombottom">
          <div class="thirdchart" style="height: 223px; width: 450px">
            <lineOnechart
              :params="lineoneparams"
              :url="lineoneurl"
            ></lineOnechart>
          </div>
          <div class="fourthchart" style="height: 223px; width: 450px">
            <lineTwochart
              :params="linetwoparams"
              :url="linetwourl"
            ></lineTwochart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import barchart from "./e4bar.vue";
import lineOnechart from "./e4lineOne.vue";
import lineTwochart from "./e4lineTwo.vue";
import radarchart from "./e4radar.vue";
export default {
  data() {
    return {
      tabData: {},
      tvfirstisActive: false,
      tvsecondisActive: false,
      tvthirdisActive: false,
      tvfourthisActive: false,
      BtvfirstisActive: false,
      BtvsecondisActive: false,
      BtvthirdisActive: false,
      BtvfourthisActive: false,
      barurl: "",
      barparams: {},
      radarurl: "",
      radarparams: {},
      lineoneurl: "",
      lineoneparams: {},
      linetwourl: "",
      linetwoparams: {},
      downoneurl: "",
      downoneparams: {},
      downtwourl: "",
      downtwoparams: {},
    };
  },
  props: ["activeName", "detailsData"],
  mounted() {
    this.barurl = "/esg/data/score_sp";
    this.barparams = {
      type: this.activeName,
      industry: this.detailsData.secondary_industry,
      isAll: 0,
    };
    this.radarurl = "/esg/data/theme_sp";
    this.radarparams = {
      type: this.activeName,
      seCode: this.detailsData.stock_code,
    };
    this.lineoneurl = "/esg/data/score_cp_line_industry";
    this.lineoneparams = {
      type: this.activeName,
      seCode: this.detailsData.stock_code,
    };
    this.linetwourl = "/esg/data/score_cp_line_region";
    this.linetwoparams = {
      type: this.activeName,
      seCode: this.detailsData.stock_code,
    };

    this.getCompanyTypeScore(this.activeName);
    this.getTabAllCompanyLevel();
    this.getTabIndustryCompanyLevel();
  },
  methods: {
    ...mapActions("dataInfo/index", {
      company_full_name: "company_full_name",
      company_type_score: "company_type_score",
      company_level: "company_level",
    }),
    getCompanyTypeScore(type) {
      let _this = this;
      let params = {
        seCode: this.detailsData.stock_code,
        type: type || "E",
      };
      this.company_type_score(params).then((res) => {
        _this.tabData = res;
      });
    },
    getTabAllCompanyLevel() {
      var _this = this;
      let params = {
        type: this.activeName || "E",
        seCode: this.detailsData.stock_code,
        dateStr: this.detailsData.record_time,
        isAll: "0",
      };
      this.company_level(params).then((res) => {
        if (res == "1") {
          _this.tvfirstisActive = true;
          _this.tvsecondisActive = false;
          _this.tvthirdisActive = false;
          _this.tvfourthisActive = false;
        }
        if (res == "2") {
          _this.tvfirstisActive = false;
          _this.tvsecondisActive = true;
          _this.tvthirdisActive = false;
          _this.tvfourthisActive = false;
        }
        if (res == "3") {
          _this.tvfirstisActive = false;
          _this.tvsecondisActive = false;
          _this.tvthirdisActive = true;
          _this.tvfourthisActive = false;
        }
        if (res == "4") {
          _this.tvfirstisActive = false;
          _this.tvsecondisActive = false;
          _this.tvthirdisActive = false;
          _this.tvfourthisActive = true;
        }
        //   ;
      });
    },
    getTabIndustryCompanyLevel() {
      var _this = this;
      let params = {
        type: this.activeName || "E",
        seCode: this.detailsData.stock_code,
        dateStr: this.detailsData.record_time,
        isAll: "1",
      };

      this.company_level(params).then((res) => {
        if (res == "1") {
          _this.BtvfirstisActive = true;
          _this.BtvsecondisActive = false;
          _this.BtvthirdisActive = false;
          _this.BtvfourthisActive = false;
        }
        if (res == "2") {
          _this.BtvfirstisActive = false;
          _this.BtvsecondisActive = true;
          _this.BtvthirdisActive = false;
          _this.BtvfourthisActive = false;
        }
        if (res == "3") {
          _this.BtvfirstisActive = false;
          _this.BtvsecondisActive = false;
          _this.BtvthirdisActive = true;
          _this.BtvfourthisActive = false;
        }
        if (res == "4") {
          _this.BtvfirstisActive = false;
          _this.BtvsecondisActive = false;
          _this.BtvthirdisActive = false;
          _this.BtvfourthisActive = true;
        }
      });
    },
  },
  watch: {},
  components: {
    barchart,
    lineOnechart,
    lineTwochart,
    radarchart,
  },
};
</script>


<style scoped lang="scss">
.arank {
  width: 40px;
  height: 48px;
  border-radius: 4px;
  float: left;
  line-height: 48px;
  display: flex;
  margin-left: 3px;
}
.best {
  color: #90cc75;
  border: 1px solid #90cc75;
}
.better {
  color: #008bce;
  border: 1px solid #008bce;
}
.good {
  color: #e2942b;
  border: 1px solid #e2942b;
}
.bad {
  color: #fc4b4e;
  border: 1px solid #fc4b4e;
}
.dustryrank {
  width: 40px;
  height: 48px;
  border-radius: 4px;
  float: left;
  line-height: 48px;
  margin-left: 18px;
  display: flex;
}
.bannerMM {
  height: 100%;
  width: 142px;
  float: left;
}
.iconfont {
  margin: 0 auto;
}
.checkcard {
  line-height: 17px;
  background: url("../../assets/white_theme/esg-sj-mingpian.png");
  height: 17px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tab {
  height: 900px;
  width: 915px;
  // margin-left: 60px;
}
/deep/.el-tabs__nav-scroll {
  background: var(--xhcj-sj-tab_01);
  color: var(--font_01);

}
.tabletfcount {
  float: left;
  width: 110px;
  height: 43px;
  font-size: 36px;
  font-weight: 700;
  color: var(--font_01);
}
.tablefttop {
  width: 148px;
  height: 45px;
  float: left;
}
.tabright {
  float: right;
  height: 51px;
  width: 535px;
  font-size: 12px;
  float: right;
  color: var(--xhcj-sj-intro);
}
.tableftupdown {
  height: 20px;
  width: 16px;
  background: url("../../assets/white_theme/esg-sj-down.png");
  float: left;
}
.tableft {
  width: 377px;
  height: 80px;
  float: left;
}
.everyranks {
  float: left;
}
.everysumday {
  float: left;
}
.tabbox {
  height: 700px;
  width: 975px;
}
.tab {
  margin: 24px 52px 0 50px;
  width: 1000px;
  height: 1000px;
}
.tabrank {
  height: 30px;
  width: 125px;
  float: left;
}
.sumranks {
  font-size: 10px;
  float: left;
  margin-top: 10px;
}
.sumday {
  font-size: 10px;
  float: left;
  color: #a1a7af;
  margin-left: 12px;
  margin-top: 10px;
}
.bannerMM {
  margin-left: 40px;
}
.bannerMMTop {
  height: 58px;
  width: 100%;
}
.bannerMMBottom {
  height: 14px;
  width: 100%;
}
.arankt {
  width: 50px;
  height: 14px;
  font-size: 10px;
  float: left;
}
.industryt {
  width: 50px;
  height: 14px;
  font-size: 10px;
  margin-left: 8px;
  float: left;
}
/deep/.el-tabs__nav {
  margin-left: 24px;
}
.tablefticon {
  line-height: 66px;
  position: relative;
  img {
    position: absolute;
    top: 14px;

    width: 16px;
    height: 20px;
  }
  .equeal {
    position: absolute;
    width: 18px;
    height: 4px;
    top: 21px;
    right: 28px;
  }
}
.everyranks {
  font-size: 10px;
  float: left;
  color: var(--xhcj-sj-dc1f);
}
.everysumday {
  font-size: 10px;
  float: left;
  color: #A1A7AF;
  margin-left: 12px;
}
.tableftrank {
  height: 36px;
  width: 208px;
  float: right;
  margin-top: 6px;
}
.tabright {
  margin-top: 6px;
}
.toprank {
  height: 16px;
}
.bottomrank {
  margin-top: 4px;
  height: 16px;
}
.topevaluate {
  width: 148px;
  height: 16px;
  float: right;
}
.bottomevaluate {
  width: 148px;
  height: 16px;
  float: right;
}
.bottomrankfont {
  float: left;
  line-height: 13px;
  font-size: 10px;
  color: var(--xhcj-sj-dc1f);

}
.toprankfont {
  float: left;
  line-height: 13px;
  font-size: 10px;
  color: var(--xhcj-sj-dc1f);
}
.tabbottom {
  height: 404px;
  width: 100%;
}
.tabtop {
  height: 80px;
  width: 100%;
}
//超出部分变为点
.overFlowHidenTop {
  overflow: hidden;
  text-align: center;
  display: inline-block;
  // width: 350px;
  white-space: nowrap;
  text-overflow: ellipsis;
  // 注: overflow:hidden; 必写
  //宽度（width）必写
  //white-space:nowrap; //不换行
  //text-overflow:ellipsis;//超出部分变为点
}
//超出部分变为点
.overFlowHidenTitle {
  overflow: hidden;
  // text-align: center;
  display: inline-block;
  // width: 350px;
  white-space: nowrap;
  text-overflow: ellipsis;
  // 注: overflow:hidden; 必写
  //宽度（width）必写
  //white-space:nowrap; //不换行
  //text-overflow:ellipsis;//超出部分变为点
}
.bottomtop {
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.bottombottom {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.thirdchart,
.fourthchart {
  margin-top: 18px;
}
.down {
  width: 100%;
  height: 451px;
  background: #ffffff;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  margin-right: 13px;
  font-size: 16px;
}
.downbox {
  width: 100%;
  height: 366px;
  padding: 0 50px;
}
.iconline {
  height: 30px;
  margin-bottom: 30px;
}
.circle {
  // float: left;
  z-index: 79;
  width: 10px;
  height: 10px;
  background-color: rgba(122, 213, 244, 1);
  border-radius: 50%;
  margin-right: 11px;
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
}
.bbb {
  display: inline-block;
  vertical-align: middle;
}
.bluecircle {
  height: 30px;
  padding-left: 20px;
}
.downbigbox {
  display: flex;
  margin-left: 34px;
  justify-content: space-between;
}
.downonebox {
  flex: 1;
  height: 188px;
}
.downtwobox {
  flex: 1;
  height: 188px;
  margin-left: 70px;
}
.topevaluate {
  display: flex;
}
.tvfirst,
.tvsecond,
.tvthird,
.tvfourth {
  flex: 1;
  text-align: center;
  line-height: 15px;
  color: #fff;
  font-size: 12px;
}
.tvfirstisActive {
  background: rgb(144, 204, 117);
}
.tvfirstdisActive {
  background: rgb(86, 122, 70);
  color: rgb(144, 124, 96);
}
.tvsecondisActive {
  background: rgb(0, 139, 206);
}
.tvseconddisActive {
  background: rgb(0, 83, 123);
  color: rgb(144, 124, 96);
}
.tvthirdisActive {
  background: rgb(226, 148, 43);
}
.tvthirddisActive {
  background: rgb(135, 88, 25);
  color: rgb(144, 124, 96);
}
.tvfourthisActive {
  background: rgb(252, 75, 78);
}
.tvfourthdisActive {
  background: rgb(151, 45, 46);
  color: rgb(144, 124, 96);
}
.tbox {
  height: 700px;
}
.tboxtop {
  height: 80px;
  width: 100%;
}
.tboxdown {
  height: 600px;
  width: 100%;
}
.tboxtitle {
  display: flex;
  height: 30px;
  margin-top: 20px;
}
// .ttitle {
//   flex: 1;
// }

.downtitle {
  margin-left: 30px;
}
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}
/deep/ el-input__inner {
  font-size: 12px;
}
.rtitle {
  flex-basis: 520px;
}
.circlef {
  font-size: 12px;
  color: var(--font_01);
}
</style>
